export const situations = [
  {
    id: 0,
    name: "全部",
    shortName: "全部",
  },
  {
    id: 1,
    name: "受注確定",
    shortName: "受注確",
  },
  {
    id: 2,
    name: "製作予定",
    shortName: "製作予",
  },
  {
    id: 3,
    name: "製作依頼",
    shortName: "製作依",
  },
  {
    id: 4,
    name: "短納期",
    shortName: "短納期",
  },
  {
    id: 5,
    name: "製作手配",
    shortName: "製作手",
  },
  {
    id: 6,
    name: "製作確定",
    shortName: "製作確",
  },
  {
    id: 7,
    name: "製作完了",
    shortName: "製作完",
  },
  {
    id: 11,
    name: "仕入予定",
    shortName: "仕入予",
  },
  {
    id: 12,
    name: "仕入確定",
    shortName: "仕入確",
  },
  {
    id: 13,
    name: "仕入済",
    shortName: "仕入済",
  },
  {
    id: 21,
    name: "出荷指示",
    shortName: "出荷指",
  },
  {
    id: 22,
    name: "出荷確定",
    shortName: "出荷確",
  },
  // {
  //   id: 23,
  //   name: "出荷済",
  //   shortName: "出荷済",
  // },
  // {
  //   id: 99,
  //   name: "キャンセル",
  //   shortName: "ｷｬﾝｾﾙ",
  // },
];
